module.exports = __webpack_public_path__ + "img/features-2.e431276.png";